import ActivitiesSection from "../components/PageSections/KatalifeFree/ActivitiesSection";
import DownloadApp from "../components/DownloadApp";
import GrowthSection from "../components/PageSections/KatalifeFree/GrowthSection";
import Hero from "../components/Hero";
import ActivityProgressSection from "../components/PageSections/KatalifeFree/ActivityProgressSection";
import ShareFeedbackSection from "../components/PageSections/KatalifeFree/ShareFeedbackSection";

const HomePage = () => {
    return (
        <main>
            <Hero />
            <ActivitiesSection />
            <ShareFeedbackSection />
            <GrowthSection />
            <ActivityProgressSection />
            <DownloadApp />
        </main>
    );
};

export default HomePage;
